import MenuItem from '@material-ui/core/MenuItem';
import PropTypes from 'prop-types';
import React from 'react';
import Select from '@material-ui/core/Select';
import { formatCurrency, startCase } from 'shared/utils/htmlHelpers';
import { withStyles } from '@material-ui/core/styles';

const styles = theme => ({
	selectKitOption: {
		bottom: '0.3em',
		marginTop: '0.4em',
		marginLeft: '3px',
		marginBottom: '1.4em',
		fontSize: '15px',
		height: '34px',
	},
	selectInput: {
		color: theme.palette.text.primary,
	},
});

/**
 * Each dropdown item in a soft kit.
 */
class SoftkitDropdown extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			softKitItem: props.component.currentSelection,
		};
	}

	render() {
		const { handleSelection, component, classes } = this.props;
		if (component.componentType === 'standard') {
			return (
				<div style={{ paddingBottom: '1.2em' }}>
					{component.componentItems.map(item => (
						<li key={item.id} style={{ fontSize: 15 }}>
							{`${startCase(item.name)}`}
						</li>
					))}
				</div>
			);
		}
		return (
			<Select
				value={this.state.softKitItem}
				onChange={event => {
					handleSelection(this.state.softKitItem, event.target.value);
					this.setState({
						softKitItem: event.target.value,
					});
				}}
				key={component.mappingId + component.componentDescription}
				className={classes.SelectKitOption}
				MenuProps={{
					transformOrigin: { vertical: 'top', horizontal: 'left' },
					getContentAnchorEl: null,
				}}
				inputProps={{ className: classes.selectInput }}
			>
				{component.componentItems.map(repItem => (
					<MenuItem key={repItem.id} value={repItem.id}>
						{`${startCase(repItem.name)} [${formatCurrency(
							repItem.adjustmentPrice * repItem.quantity,
						)}]`}
					</MenuItem>
				))}
			</Select>
		);
	}
}

SoftkitDropdown.propTypes = {
	classes: PropTypes.shape({
		selectKitOption: PropTypes.string,
	}).isRequired,
	component: PropTypes.instanceOf(Object).isRequired,
	handleSelection: PropTypes.func.isRequired,
};

export default withStyles(styles, { name: 'SoftkitDropdown' })(SoftkitDropdown);
